<template>
  <div>
    <HeaderSearchLots :img_header="header_image" header="รายละเอียดล็อตสินค้า"/>
    <Search_ProductLots_Detail />
  </div>
</template>

<script>
import HeaderSearchLots from "@/components/admin/search_lot_product/headersearch/HeaderSearchLots";
import HeaderImage from "@/assets/checkk.png";
import Search_ProductLots_Detail from "../../../components/admin/search_lot_product/Search_ProductLots_Detail.vue";

export default {
  name: "SearchProductLotsDetailPage",
  components: {
    Search_ProductLots_Detail,
    HeaderSearchLots
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>